import(/* webpackMode: "eager" */ "/github/workspace/src/app/[locale]/merchants/faqs/page.tsx");
